module.exports = __webpack_public_path__ + "media/containers/common/Images/icon_dwelling_tel-6a6ef6d72aa9da62b5e93de2e3f47931.svg";